import i18n from "../../../../constants/i18n";
import { USER_REFERRAL_CODE_USAGE_HEADERS } from "../../../../constants/table-custom-headers/User";
import getReferralCodeStore from "../../../../stores/user-store/referral-code-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const UserReferralCodeUsageData = withLiteObserverAndTheme(() => {
  const userReferralCodeUsageData =
    getReferralCodeStore().userReferralCodeUsageData.get();

  return (
    <Et3Table
      columns={USER_REFERRAL_CODE_USAGE_HEADERS}
      rows={userReferralCodeUsageData}
      title={i18n.get("USER_REFERRAL_CODE_USAGE_TABLE")}
      shouldBeFlagged={false}
      titleKey={"USER_REFERRAL_CODE_USAGE_TABLE"}
    />
  );
});
export default UserReferralCodeUsageData;
